<template>
  <v-layout wrap class="app-content">
    <m-form class="col-3 pa-0" ref="form" @submit.prevent="logar">
      <v-flex style="min-height: 81%" class="pt-16">
        <v-flex mr-10 ml-15 class="d-flex">
          <div class="logo-128">
            <img
              src="https://www.unifisa.com.br/wp-content/uploads/2022/01/logo.png"
              class="img-logo"
              alt="logo-assinatura"
            />
          </div>
        </v-flex>
        <v-flex class="ml-15 texto-large pt-16 mr-10">
          <label>Gestão de Notificações </label>
        </v-flex>
        <v-flex xs12 mt-9 mr-10 ml-15>
          <label class="label-input" for="login">Login</label>
          <m-text-field
            id="login"
            placeholder="Login"
            v-model="model.login"
            v-lowercase
            dense
            :rules="[rules.required]"
            outlined
            validate-on-blur
          />
        </v-flex>
        <v-flex xs12 mt-n2 mr-10 ml-15>
          <label class="label-input" for="Senha">Senha</label>
          <m-text-field
            id="Senha"
            placeholder="Senha"
            v-model="model.senha"
            :rules="[rules.required]"
            :type="pass_visible ? 'text' : 'password'"
            dense
            outlined
            validate-on-blur
          >
            <v-icon
              slot="append"
              @click="pass_visible = !pass_visible"
              :color="pass_visible ? 'primary' : undefined"
            >
              {{ pass_visible ? "far fa-eye" : "far fa-eye-slash" }}
            </v-icon>
          </m-text-field>
        </v-flex>
        <v-flex mr-10 ml-15 class="d-flex">
          <v-btn
            color="primary"
            x-large
            class="button btn-default"
            type="submit"
            >Entrar</v-btn
          >
        </v-flex>
        <v-flex mt-5 mr-10 ml-15 class="d-flex">
          <a v-on:click="dialog = true">Esqueci minha senha</a>
        </v-flex>
      </v-flex>
      <!-- <v-flex class="footer col-12">
        <v-flex xs12 mt-3 class="d-flex column justify-center">
          <img src="../assets/img/logo_assinatura.png" alt="Logo Assinatura">
        </v-flex>
        <v-flex xs12 ma-3 mb-2 class="d-flex justify-center font-link">
        </v-flex>
      </v-flex> -->
    </m-form>

    <v-flex class="col-9 bg"></v-flex>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <template>
        <v-form @submit.prevent="enviaEmail">
          <v-card>
            <v-card-title>
              <span class="text-h5">Recuperação de senha</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <v-flex mb-5 class="d-flex">
                  Para recuperar a sua senha, informe seu endereço de e-mail.
                </v-flex>
                <v-flex class="d-flex">
                  <m-text-field
                    placeholder="Digite seu e-mail"
                    :rules="[rules.required]"
                    dense
                    outlined
                    validate-on-blur
                    v-model="email"
                  />
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="button btn-default"
                @click="dialog = false"
              >
                Fechar
              </v-btn>
              <v-btn
                color="primary"
                class="button btn-default"
                type="submit"
                @click="dialog = false"
                v-bind:disabled="!email"
              >
                ENVIAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
import Rules from "../plugins/validation";
import MForm from "../components/MForm";
import { alert, error } from "@/plugins/helpers";
export default {
  name: "Login",
  components: { MForm },
  data: () => ({
    model: {
      login: "",
      senha: "",
    },
    dialog: false,
    email: "",
    pass_visible: false
  }),
  computed: {
    rules: () => Rules,
  },
  methods: {
    async logar() {
      if (this.$refs.form.validate()) {
        try {
          const { data } = await this.$http.post("/login", this.model);
          this.$session.set("token", data.jwt);
          this.$router.replace("/");
        } catch (e) {
          error(null, "Não foi possível realizar o login!");
        }
      } else {
        this.$refs.form.validate();
      }
    },

    async enviaEmail() {
      try {
        const { data } = await this.$http.get(
          "/solicitarNovaSenha/" + this.email
        );

        alert(data);
      } catch (e) {
        error(null, e.response.data).then(() => { this.dialog = true; });
        
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  background: var(--v-primary-base);
}
.form-layout {
  margin: auto;
  max-width: 500px;
}
.footer {
  background-color: #f7f7f7;
  font-size: 12px;
}
.bg {
  background: linear-gradient(to right, #0e6c3c66, #0e6c3c66),
    url(../assets/img/login-bg-min.jpg) center center/cover no-repeat;
  height: 100%;
  position: fixed;
  right: 0;
  min-height: 100%;
}
</style>
